export default __webpack_public_path__ + "static/media/bpb-dirty-la.e2dfa26a.jpg";